module.exports = __webpack_public_path__ + "static/img/06.bfa6e924.jpg";